import { useEffect } from 'react';
import { usePrevious } from 'react-use';
export const useScrollToLastChild = ({ current }, fields) => {
    const previousFields = usePrevious(fields);
    useEffect(() => {
        if (fields.length > ((previousFields === null || previousFields === void 0 ? void 0 : previousFields.length) || 1) && current) {
            const childrenLength = current.childNodes.length;
            const lastChild = current.childNodes[childrenLength - 1];
            if (lastChild instanceof HTMLElement) {
                lastChild.scrollIntoView({ behavior: 'smooth' });
            }
        }
    }, [current, fields, previousFields]);
};
